import { render, staticRenderFns } from "./ClearanceCertificate.vue?vue&type=template&id=1a9bea4d&scoped=true&"
import script from "./ClearanceCertificate.vue?vue&type=script&lang=js&"
export * from "./ClearanceCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9bea4d",
  null
  
)

export default component.exports